import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RequestType } from 'common/constants/app.constant';
import { WelcomeListingModel, WelcomeModel } from 'common/models/pagemodels/welcome/welcome.model';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { ListComponentData } from 'common/models/utilitymodels/list.model';
import { ListResolverService } from 'common/resolvers/list.resolver';
import { WelcomeWidgetService } from 'common/services/component_services/welcome/welcome.widget.service';
import { SystemService } from 'common/services/core_services/system.service';

@Injectable({
    providedIn: 'root',
})
export class WelcomeResolver extends ListResolverService<WelcomeModel, WelcomeListingModel> {
    constructor(protected ls: WelcomeWidgetService, protected router: Router, protected systemService: SystemService) {
        super(ls, router);
    }

    override getComponentData(): any {
        const data = new ListComponentData();
        return data;
    }

    getResolverMessage(message: RouteMessage) {
        const routeMsg = new RouteMessage();
        routeMsg.type = RequestType.GET;
        routeMsg.transferData = null;
        // this.router.navigate([''], { state: routeMsg, replaceUrl: true });

        return routeMsg;
    }
}
